import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <span className={`inline-block uppercase tracking-[0.2em] text-sm font-bold text-[#16A34A] ${className}`}>
      {children}
    </span>
  );
}
